import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getAllCategoriesWithoutBlockedCategory } from "../../redux/actions/categoryAction";
import { getAllProductsSearch  } from "../../redux/actions/productsAction";
import {  getAllVendors } from "../../redux/actions/usersActions";


const NavBarSearchHook = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const[searchParams,setSearchParams]=useSearchParams();
  const dispatch=useDispatch();
  
  const [searchWord, setSearchWord] = useState(()=>searchParams.get('keyword') ? searchParams.get('keyword') : '');
  const[homeCategories,setHomeCategories]=useState([]);
  const[pagination,setPagination]=useState('');
  const[selectCategoryState,setSelectCategoryState]=useState(()=>searchParams.get('search_categories_param') ? searchParams.get('search_categories_param') : '');
  const[selectedVendor,setSelectedVendor]=useState('');

  // search_categories_param
 //const [, , , getProduct] = ViewSearchProductHooks(searchWord);

let limitNumber = 8;

  useEffect(() => {
    dispatch(getAllCategoriesWithoutBlockedCategory());
    let vendorsQuery='?status=true';

    dispatch(getAllVendors(vendorsQuery));

    //getProduct();
  }, [dispatch]);

  const settingsRes = useSelector((state) => state.settingsReducers.settings);
  const activeCategoriesRes=useSelector((state)=>state.allCategory.categoriesWithoutBlocked);
  const vendors = useSelector((state) => state.usersReducers.allVendors);

  //console.log('activeCategoriesRes');
  // console.log(activeCategoriesRes);

  useEffect(()=>{
    if(activeCategoriesRes) setHomeCategories(activeCategoriesRes);
  },[activeCategoriesRes]);


  const onChangeSearch = async (e) => {

    if(selectedVendor!=""){
     // await dispatch(getAllVendorProductsById(selectedVendor,`limit=${20}&page=${1}`));
      let vendorOBJ=vendors?.find(vendor=>vendor._id==selectedVendor);
      return navigate(`/${vendorOBJ?.username}?page=1`);
    }
   
    //for pagination
    localStorage.setItem("page",1);
    // if(selectCategoryState=='') await dispatch(getAllProductsSearch(`keyword=${searchWord}&limit=2`,searchWord));
    // else await dispatch(getAllProductsSearch(`categories=${selectCategoryState}&limit=12`,selectCategoryState))
   
    

    
    if (location.pathname !== '/products') {
     // const url = new URL("/products");
      let queryParams = new URLSearchParams();

// Add query parameters dynamically
    //  let navigateUrl='/products?';
         // navigateUrl+=`&keyword=${searchWord}`;
        // navigateUrl+=`&categories=${selectCategoryState}`;
      if(searchWord) queryParams.set("keyword", searchWord);

      if(selectCategoryState) queryParams.set("search_categories_param", selectCategoryState);

       console.log("queryParams",queryParams.toString());

      const relativeUrl = `/products?${queryParams.toString()}`;

      navigate(relativeUrl);
    
    }
    else{

      // لو انت  في صفحة المنتجات  
      let search_url="";

      if(searchWord){
       // keyword
       searchParams.set('keyword',searchWord);
        search_url+=`keyword=${searchWord}`;
       // old `keyword=${searchWord}&limit=${limitNumber}`,{keyword:searchWord,type:'keyword'}
      // await dispatch(getAllProductsSearch(`keyword=${searchWord}&limit=${limitNumber}`));

      } 

      if(selectCategoryState){
             searchParams.set('search_categories_param',selectCategoryState);    
              search_url+=`categories=${selectCategoryState}`;
      }

         searchParams.set('page',1);
         setSearchParams(searchParams);

          search_url+=`&limit=${limitNumber}&page=${1}`;

          console.log('search_url',search_url);

      await dispatch(getAllProductsSearch(search_url,{keyword:searchWord,type:'keyword'}));
    // else if(selectCategoryState !=='') await dispatch(getAllProductsSearch(`categories=${0}&keyword=${searchWord}&limit=${limitNumber}`,searchWord));
      // else{
      //   searchParams.set('search_categories_param',selectCategoryState);
      //   searchParams.set('page',1);
      //   setSearchParams(searchParams);
      //   await dispatch(getAllProductsSearch(`categories=${selectCategoryState}&limit=${limitNumber}`,{keyword:selectCategoryState,type:'cat'}));
      // } 

    }

   //await getProduct();
  };

  
  return [onChangeSearch, searchWord, setSearchWord, homeCategories ,pagination ,selectCategoryState,setSelectCategoryState ,settingsRes,selectedVendor,setSelectedVendor];
};

export default NavBarSearchHook;